import fetch from 'isomorphic-fetch';
import { getCountryDialCode } from '../actions/requestFormActions';
import * as actionTypes from '../consts/actionTypes';
import { createUniqueId } from '../helpers/crypto';
import { toQueryString } from '../helpers/querystring';
import { IContactFormData } from '../interfaces/IContactForm';
import { initialState } from '../reducers/contactForm/contactForm';
import { submitContactForm } from '../reducers/contactForm/contactFormMappers';
export const setContactFormInitialData = (payload) => (dispatch, getState) => {
    const { pageData } = getState();
    const { countryCodes } = pageData.brandConfig.requestForm;
    const { countryCode } = pageData.appConfig;
    const countryCodeSelected = getCountryDialCode(countryCode, countryCodes);
    Object.keys(payload).map((channel) => {
        payload[channel].countryCode = countryCodeSelected;
    });

    dispatch({
        type: actionTypes.setContactFormInitialData,
        payload,
    });
};

export const deleteContactFormData = (channel: string) => (dispatch, getState) => {
    const { pageData } = getState();
    const { countryCodes } = pageData.brandConfig.requestForm;
    const { countryCode } = pageData.appConfig;
    const countryCodeSelected = getCountryDialCode(countryCode, countryCodes);
    const contactFormData = initialState[channel];
    contactFormData.countryCode = countryCodeSelected;
    dispatch({
        type: actionTypes.deleteContactFormData,
        payload: {
            [channel]: contactFormData,
        },
    });
};

export const updateContactFormData = ({ channel, key, value }) => ({
    type: actionTypes.updateContactFormData,
    payload: { channel, key, value },
});

export const onContactFormSubmit = (channel: string) => async (dispatch, getState) => {
    const { contactForm } = getState();
    const contactFormData: IContactFormData = contactForm[channel];

    if (!submitContactForm(contactFormData).isValid) {
        dispatch(updateContactFormData({ channel, key: 'isSubmitted', value: true }));
        return;
    }

    const timeZone = new Date().getUTCDate().toString();

    const {
        firstName,
        lastName,
        phoneNumber,
        customerMail,
        messageBody,
        advisorName,
        advisorCompanies,
        advisorPhone,
        advisorLanguages,
    } = contactFormData;

    let requestData: any = {
        action: 'advisorcontact',
        channel,
        timeZone,
        bkIdCode: createUniqueId(),
        firstName,
        lastName,
        phoneNumber,
        customerMail,
        messageBody,
    };
    if (channel === 'advisorModal') {
        requestData = {
            ...requestData,
            advisorName,
            advisorCompanies,
            advisorPhone,
            advisorLanguages,
        };
    }

    const ajaxHandlerEndpoint = '/wp-content/themes/dreamlines/ajax/ajaxhandler.php';

    dispatch({ type: actionTypes.showLoadingIndicator });

    try {
        const response = await fetch(ajaxHandlerEndpoint, {
            method: 'POST',
            body: toQueryString(requestData, null),
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
            },
        });
        dispatch({
            type: actionTypes.updateContactFormData,
            payload: { channel, key: 'isSent', value: true },
        });
    } catch (error) {
        console.error(error, 'Could not submit contact form');
        dispatch({
            type: actionTypes.updateContactFormData,
            payload: { channel, key: 'isSubmitError', value: true },
        });
    }

    dispatch({ type: actionTypes.hideLoadingIndicator });
};
